import React, { useRef, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./AdminOperations.css";
import { routeCreateUser } from "./constants";

export const CreateUser = () => {
  const [email, setEmail] = useState("");
  const [nombre, setNombre] = useState("");
  const [apellido, setApellido] = useState("");
  const [telefono, setTelefono] = useState("");
  const [imagen, setImagen] = useState("");
  const [contraseña, setContraseña] = useState("");
  const [rol, setRol] = useState("");
  const [matricula, setMatricula] = useState("");
  const [estaGuardando, setEstaGuardando] = useState(false);
  const [resultado, setResultado] = useState(null);
  const peticionEnProceso = useRef(false);
  const navigate = useNavigate();

  const limpiarFormulario = () => {
    setEmail("");
    setNombre("");
    setApellido("");
    setTelefono("");
    setImagen("");
    setContraseña("");
    setRol("");
    setMatricula("");
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (peticionEnProceso.current) {
      return;
    }

    peticionEnProceso.current = true;
    setEstaGuardando(true);
    setResultado(null);

    try {
      const response = await axios.post(routeCreateUser, {
        email,
        nombre,
        apellido,
        telefono,
        imagen,
        contraseña,
        rol,
        matricula,
      });

      setResultado({
        tipo: "success",
        mensaje: response.data?.message || "El usuario se creó correctamente.",
      });
      limpiarFormulario();
    } catch (error) {
      console.error("Error al crear usuario", error);

      const esDuplicado = error.response?.status === 409;
      setResultado({
        tipo: esDuplicado ? "warning" : "error",
        mensaje:
          error.response?.data?.message ||
          error.response?.data?.error ||
          (esDuplicado
            ? "Ya existe un usuario con ese correo o matrícula."
            : "No fue posible crear el usuario. Inténtalo de nuevo."),
      });
    } finally {
      peticionEnProceso.current = false;
      setEstaGuardando(false);
    }
  };

  return (
    <div className="admin-operation-page">
      <main className="admin-operation-container admin-operation-container-narrow">
        <header className="admin-operation-header">
          <p className="admin-operation-eyebrow">Administración de usuarios</p>
          <h1>Crear usuario</h1>
          <p>
            Registra los datos de acceso y asigna el rol con el que la persona
            utilizará la plataforma.
          </p>
        </header>

        <form className="admin-operation-panel" onSubmit={handleSubmit}>
          <div className="admin-operation-form-grid">
            <div className="admin-operation-field">
              <label htmlFor="create-user-email">Correo electrónico</label>
              <input
                id="create-user-email"
                type="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                disabled={estaGuardando}
                required
              />
            </div>

            <div className="admin-operation-field">
              <label htmlFor="create-user-id">Matrícula</label>
              <input
                id="create-user-id"
                type="text"
                value={matricula}
                onChange={(event) => setMatricula(event.target.value)}
                disabled={estaGuardando}
                required
              />
            </div>

            <div className="admin-operation-field">
              <label htmlFor="create-user-name">Nombre</label>
              <input
                id="create-user-name"
                type="text"
                value={nombre}
                onChange={(event) => setNombre(event.target.value)}
                disabled={estaGuardando}
                required
              />
            </div>

            <div className="admin-operation-field">
              <label htmlFor="create-user-lastname">Apellido</label>
              <input
                id="create-user-lastname"
                type="text"
                value={apellido}
                onChange={(event) => setApellido(event.target.value)}
                disabled={estaGuardando}
                required
              />
            </div>

            <div className="admin-operation-field">
              <label htmlFor="create-user-phone">Teléfono</label>
              <input
                id="create-user-phone"
                type="tel"
                value={telefono}
                onChange={(event) => setTelefono(event.target.value)}
                disabled={estaGuardando}
              />
            </div>

            <div className="admin-operation-field">
              <label htmlFor="create-user-role">Rol</label>
              <select
                id="create-user-role"
                value={rol}
                onChange={(event) => setRol(event.target.value)}
                disabled={estaGuardando}
                required
              >
                <option value="">Selecciona un rol</option>
                <option value="Admin">Admin</option>
                <option value="Maestro">Maestro</option>
                <option value="Alumno">Alumno</option>
                <option value="Monitor">Monitor – Administrador</option>
              </select>
            </div>

            <div className="admin-operation-field">
              <label htmlFor="create-user-password">Contraseña</label>
              <input
                id="create-user-password"
                type="password"
                value={contraseña}
                onChange={(event) => setContraseña(event.target.value)}
                disabled={estaGuardando}
                required
              />
            </div>

            <div className="admin-operation-field">
              <label htmlFor="create-user-image">URL de imagen</label>
              <input
                id="create-user-image"
                type="url"
                value={imagen}
                onChange={(event) => setImagen(event.target.value)}
                placeholder="https://..."
                disabled={estaGuardando}
              />
            </div>
          </div>

          {resultado && (
            <div
              className={`admin-operation-status admin-operation-status-${resultado.tipo}`}
              role="status"
              aria-live="polite"
            >
              {resultado.mensaje}
            </div>
          )}

          <div className="admin-operation-actions">
            <button
              className="admin-operation-button"
              type="submit"
              disabled={estaGuardando}
            >
              {estaGuardando ? "Creando usuario..." : "Crear usuario"}
            </button>
            <button
              className="admin-operation-button admin-operation-button-secondary"
              type="button"
              onClick={() => navigate("/admin-home")}
              disabled={estaGuardando}
            >
              Regresar al inicio
            </button>
          </div>
        </form>
      </main>
    </div>
  );
};
